import { reports } from "../reports";
import { tableColumnTypes } from "../../../tableColumnTypes";
import UserIcon from "../../../../components/Common/SvgIcons/ReportIcons/UserIcon";
import ClassIcon from "../../../../components/Common/SvgIcons/ReportIcons/ClassIcon";
import Button from "../../../../components/Common/Button/Button";
import EmailIcon from "../../../../components/Common/SvgIcons/ReportIcons/EmailIcon";
import { FormattedMessage } from "react-intl";

export const classTabularReport = {
  label: <FormattedMessage id="REPORTCLASS_TEXT" />,
  path: (tenantName) => `/${tenantName}/reports/tabularReport`,
  buttons: (navigate) => [
    {
      key: 1,
      label: "User Graphical Report",
      path: `${classTabularReport.path}/userTabularReport`,
      icon: UserIcon,
      onClick: () => navigate(`${classTabularReport.path}/userTabularReport`),
    },
    {
      key: 2,
      label: "Class Graphical Report",
      path: `${classTabularReport.path}/classTabularReport`,
      icon: ClassIcon,
      onClick: () => navigate(`${classTabularReport.path}/classTabularReport`),
    },
  ],
  navLinks: (navigate) => [
    {
      key: 1,
      label: "Reports",
      path: `${reports.path}`,
      onClick: () => navigate(`${reports.path}`),
    },
    {
      key: 2,
      label: <FormattedMessage id="REPORTCLASS_TEXT" />,
      path: `${reports.path}`,
      onClick: () => navigate(`${reports.path}`),
    },
  ],
  columns: (navigate, handleUserPopUp, handleEmailReminder) => [
    {
      ID: 1,
      name: <FormattedMessage id="REPORT_CLASSNAME_TXT" />,
      fieldName: "ClassName",
      value: (row) =>
        row.ClassesAssigned > 0 && (
          <span
            style={{
              textDecoration: "underline",
              color: "#0051BC",
              cursor: "pointer",
            }}
            onClick={() => handleUserPopUp(row.ClassId)} title={row.ClassName}
          >
            {row.ClassName?.length > 25 ? row?.ClassName?.slice(0, 23) + "..." : row?.ClassName}
          </span>
        ),
      sort: true,
      type: tableColumnTypes.STRING,
    },
    {
      ID: 2,
      name: <FormattedMessage id="ASSIGNED_TEXT" />,
      fieldName: "ClassesAssigned",
      value: (row) => row.ClassesAssigned,
      sort: true,
      type: tableColumnTypes.NUMBER,
    },
    {
      ID: 3,
      name: <FormattedMessage id="REPORT_NOTYETSTRT_TXT" />,
      fieldName: "ClassesNotStarted",
      value: (row) => row.ClassesNotStarted,
      sort: true,
      type: tableColumnTypes.NUMBER,
    },
    {
      ID: 4,
      name: <FormattedMessage id="InProgress" />,
      fieldName: "ClassesInProgress",
      value: (row) => row.ClassesInProgress,
      sort: true,
    },
    {
      ID: 5,
      name: <FormattedMessage id="Report_Completed" />,
      fieldName: "ClassesCompleted",
      value: (row) => row.ClassesCompleted,
      sort: true,
    },
    {
      ID: 6,
      name: <FormattedMessage id="REPORT_ARCHIVED_TEXT" />,
      fieldName: "Archived",
      value: (row) => row.Archived,
      sort: true,
    },
    {
      ID: 7,
      name: <FormattedMessage id="REPORT_COMPLETION_TXT" />,
      fieldName: "PercentageCompletion",
      value: (row) => row.PercentageCompletion,
      sort: true,
    },
    {
      ID: 8,
      name: <FormattedMessage id="REPORT_EmailRemainder_TXT" />,
      fieldName: "Email",
      value: (row) => (
        <span
          // style={{
          //   textDecoration: "underline",
          //   color: "#0051BC",
          //   cursor: "pointer",
          // }}
          onClick={() => handleEmailReminder(row.ClassId)}
        >
          <EmailIcon />
          {/* <Button label="Remind" dark small /> */}
        </span>
      ),
      //sort: true,
    },
  ],
};
